import React, { useCallback } from 'react';
import { useReactiveVar } from '@apollo/client';
import { Dialog, DialogContent } from '@mui/material';
import { nonWorkingDaysModalVar } from '../../variables';
import NonWorkingDayModalComponent from './NonWorkingDayModalComponent';
import useQuery from 'hooks/apollo/useQuery';
import { NON_WORKING_DAY_CONTEXTS_QUERY, SITES_QUERY } from '../../list/queries';

const NonWorkingDayModalContainer = () => {
  const { data: dictionaryContext } = useQuery(NON_WORKING_DAY_CONTEXTS_QUERY);
  const { data: sites } = useQuery(SITES_QUERY);

  const nonWorkingDaysModal = useReactiveVar(nonWorkingDaysModalVar);

  const close = useCallback(
    (_, reason) => {
      if (reason === 'backdropClick') return true;
      nonWorkingDaysModal({ open: false });
    },
    [nonWorkingDaysModal]
  );

  return (
    <Dialog open={nonWorkingDaysModal.open} maxWidth='sm' scroll={'body'} onClose={close} TransitionProps={{ exit: false }}>
      <DialogContent>
        {nonWorkingDaysModal.open && (
          <NonWorkingDayModalComponent nonWorkingDay={nonWorkingDaysModal.item} dictionaryContext={dictionaryContext} sites={sites} />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default NonWorkingDayModalContainer;
